import Vue from 'vue'
import Loading from './loading/index'
import ImageCrop from './imageCrop/index'

Vue.component('IkLoading', Loading)
Vue.component('IkImageCrop', ImageCrop)